import { LogicalOperator } from '@aipb/gulliver/castor/model';
import { CastorConfigRepository, DetailRepository, SearchRepository } from '@aipb/gulliver/catalog/data-access';
import { FormSettingsModel, SearchFormMode } from '@aipb/gulliver/catalog/model';
import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { TranslocoModule } from '@jsverse/transloco';
import { combineLatest, Observable } from 'rxjs';
import { DetailSettingsComponent, ResultSettingsComponent, SearchSettingsComponent } from '../../components';

interface SettingsPageVM {
  searchResultTabsLocked: boolean;
  formSettings: FormSettingsModel;
  detailTabsLocked: boolean;
  detailCompactHeader: boolean;
  activeLogicalOperator: LogicalOperator;
  searchFormMode: SearchFormMode;
}

@Component({
  selector: 'cat-settings',
  templateUrl: './settings-page.component.html',
  styleUrls: ['./settings-page.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatDividerModule,
    TranslocoModule,
    SearchSettingsComponent,
    DetailSettingsComponent,
    ResultSettingsComponent
  ]
})
export class SettingsPageComponent {
  detailRepository = inject(DetailRepository);
  searchRepository = inject(SearchRepository);
  castorConfigRepository = inject(CastorConfigRepository);

  vm$: Observable<SettingsPageVM> = combineLatest({
    searchResultTabsLocked: this.searchRepository.tabsLocked$,
    formSettings: this.searchRepository.formSettings$,
    detailTabsLocked: this.detailRepository.tabsLocked$,
    detailCompactHeader: this.detailRepository.compactHeader$,
    activeLogicalOperator: this.castorConfigRepository.activeLogicalOperator$,
    searchFormMode: this.searchRepository.searchFormMode$
  });
}
